import React, { Component } from "react";
import { Wrapper, Title, Scroll } from "app/NativeComponents/common";

import ActivityItems from "./ActivityItems";
import MessageAndNoteBox from "app/DealMachineCore/snippets/MessageAndNoteBox";
import DetailedOptionsButton from "./DetailedOptionsButton";

class Activity extends Component {
  renderTitle(title) {
    if (this.props.include_title) {
      return (
        <Wrapper style={{ padding: 20 }}>
          <Title>{title}</Title>
        </Wrapper>
      );
    }
  }

  render() {
    if (this.props.active_property.deal) {
      return (
        <Wrapper
          style={{
            height: "100%",
            flex: 1
          }}
        >
          <Scroll
            style={{
              flex: 1,
              maxHeight: "100%"
            }}
          >
            <Wrapper style={{ paddingTop: 10 }}>
              <ActivityItems {...this.props} />
            </Wrapper>
          </Scroll>
          <MessageAndNoteBox
            include_tabs={false}
            box_tab={"note"}
            onNoteSubmit={({ message, onSuccess = null }) => {
              const { token, active_property } = this.props;
              if (message.trim().length > 0) {
                this.props.updateNote({
                  token,
                  payload: {
                    id: 0,
                    activity_type: "note",
                    text: message,
                    date_created: null,
                    user_id: this.props.user.id,
                    firstname: this.props.user.firstname,
                    lastname: this.props.user.lastname,
                    email: this.props.user.email,
                    image: this.props.user.image
                  },
                  type: "post_note",
                  deal_id: active_property.deal.id
                });

                if (onSuccess) {
                  onSuccess();
                }
              }
            }}
            renderHeader={() => {
              return <DetailedOptionsButton {...this.props} />;
            }}
          />
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default Activity;
